// extracted by mini-css-extract-plugin
module.exports = {"titleCard":"InsightsTitleCard_titleCard__1VnE8","title":"InsightsTitleCard_title__15Mc2","subtitle":"InsightsTitleCard_subtitle__PzGoq"};